import {Component, Injector} from '@angular/core';
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {AssociationService} from "./services/association.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";

@Component({
    selector: 'app-association-list',
    templateUrl: './association-list.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class AssociationListComponent extends BasePageComponentDirective<any> {

    associations: any[] = [];
    showCloseSearch = false;

    constructor(
        injector: Injector,
        private associationService: AssociationService,
    ) {
        super(injector);
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.query();
    }

    query(): void {
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['providerName', 'email'];
        this.associationService.getAll(this.pageQuery).then(r => {
            this.associations = r.content;

            this.page.emit(r);
        });
    }

    searchUser($event: any) {
        if ($event.key === 'Enter') {
            this.searchTerm = this.pageQuery.search;
            this.query();
            this.showCloseSearch = true;
        }
    }

    clearSearch() {
        this.searchTerm = '';
        this.pageQuery.search = '';
        this.query();
        this.showCloseSearch = false;
    }

    addNewAssociation() {
        this.router.navigate(['/office/association/add-new']).then();
    }

    detailAssociation(providerId: number) {
        this.router.navigate(['/office/association/detail', providerId]).then();
    }

    deleteAssociation(providerId: number) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const confirm = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: "Delete Association" ,
                subMessage: "Are you sure want to delete association?",
                buttonOkLabel: 'Yes, Delete',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        confirm.componentInstance.result.subscribe(r => {
            if(r) {
                this.associationService.deleteById(providerId).then(_ => {
                    this.showAlertDark('Association', 'Association has been deleted successfully', '');
                    this.query();
                })

            }
        })
    }
}
